import { ListBox } from '$comp/navigation-bar-tool-box/components/list-box'
import { t } from '$i18n'
import { closeNavbarToolBox } from '$logic/router'
import {
  openFormCreator,
  openGeneralExamCreator,
  openPollCreator,
} from '$logic/wapps/business'

export function UsefulTools() {
  return (
    <ListBox
      title={t('navigationBarToolBox.usefulTools.title')}
      titleSx={{
        background: 'linear-gradient(0deg, #FAD961 0%, #F76B1C 100%)',
      }}
      items={[
        {
          title: t('wapps.poll'),
          onClick: async () => {
            await closeNavbarToolBox()
            openPollCreator()
          },
        },
        {
          title: t('wapps.form'),
          onClick: async () => {
            await closeNavbarToolBox()
            openFormCreator()
          },
        },
        {
          title: t('wapps.generalExam'),
          onClick: async () => {
            await closeNavbarToolBox()
            openGeneralExamCreator()
          },
        },
      ]}
      borderColor="#FAD860"
    />
  )
}
